/* FIELDWRKS orange cursor dot.
   A plain-JavaScript port of the SpringMouseFollow component: the same spring
   (mass 0.1, damping 10, stiffness 131) drives position, opacity and scale, so it
   moves identically without shipping React or framer-motion to the storefront.
   The real cursor stays; the dot trails it. Fine pointers only, never touch.
   On light surfaces the dot multiplies, so dark text under it stays readable;
   over dark surfaces and photos it paints solid so it stays visible. */
(function () {
  var dot = document.querySelector('[data-fw-cursor-dot]');
  if (!dot || dot.__fwCursor) return;
  dot.__fwCursor = true;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var MASS = 0.1, DAMPING = 10, STIFFNESS = 131;
  var STEP = 1 / 240; // fixed sub-step keeps this stiff, heavily damped spring stable at 60Hz
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function spring(v) { return { x: v, v: 0, to: v }; }
  var px = spring(-100), py = spring(-100), op = spring(0), sc = spring(0);
  var all = [px, py, op, sc];
  var raf = 0, last = 0, placed = false;

  function advance(s, dt) {
    var a = (-STIFFNESS * (s.x - s.to) - DAMPING * s.v) / MASS;
    s.v += a * dt;
    s.x += s.v * dt;
  }
  function atRest(s) { return Math.abs(s.x - s.to) < 0.01 && Math.abs(s.v) < 0.01; }
  function paint() {
    dot.style.opacity = String(Math.min(1, Math.max(0, op.x)));
    dot.style.transform = 'translate3d(' + px.x.toFixed(2) + 'px,' + py.x.toFixed(2) + 'px,0) scale(' + Math.max(0, sc.x).toFixed(3) + ')';
  }
  function tick(t) {
    var dt = last ? Math.min((t - last) / 1000, 0.064) : STEP;
    last = t;
    if (reduce.matches) {
      all.forEach(function (s) { s.x = s.to; s.v = 0; });
    } else {
      while (dt > 0) {
        var h = Math.min(STEP, dt);
        for (var i = 0; i < all.length; i++) advance(all[i], h);
        dt -= h;
      }
    }
    paint();
    if (all.every(atRest)) {
      all.forEach(function (s) { s.x = s.to; s.v = 0; });
      paint();
      raf = 0; last = 0;
      return;
    }
    raf = requestAnimationFrame(tick);
  }
  function wake() { if (!raf) raf = requestAnimationFrame(tick); }

  // Surface under the pointer: dark backgrounds and media get a solid dot.
  var memo = new WeakMap();
  function darkUnder(el) {
    if (!el || el.nodeType !== 1) return false;
    if (memo.has(el)) return memo.get(el);
    var dark = false;
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      if (/^(IMG|VIDEO|CANVAS|PICTURE|IFRAME)$/.test(n.tagName)) { dark = true; break; }
      var m = getComputedStyle(n).backgroundColor.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?/);
      if (m && (m[4] === undefined || parseFloat(m[4]) > 0.5)) {
        dark = (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) < 110;
        break;
      }
    }
    memo.set(el, dark);
    return dark;
  }

  // A modal dialog such as the cart drawer renders in the browser's top layer, above
  // every z-index. While one is open the dot lives inside it so it stays visible,
  // and it returns to <body> once the dialog closes. Re-appending also restores the
  // dot if a section re-render ever removes it.
  function host() {
    var modal = null;
    try { modal = document.querySelector('dialog:modal'); }
    catch (err) { modal = document.querySelector('dialog[open]'); }
    var want = modal || document.body;
    if (dot.parentNode !== want) want.appendChild(dot);
  }

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    host();
    if (!placed) { px.x = px.to = e.clientX; py.x = py.to = e.clientY; placed = true; }
    px.to = e.clientX; py.to = e.clientY;
    op.to = 1; sc.to = 1;
    wake();
  }, { passive: true });

  document.addEventListener('pointerover', function (e) {
    dot.classList.toggle('is-solid', darkUnder(e.target));
  }, { passive: true });

  function hide() { op.to = 0; sc.to = 0; wake(); }
  document.addEventListener('mouseout', function (e) { if (!e.relatedTarget) hide(); });
  window.addEventListener('blur', hide);
  document.addEventListener('visibilitychange', function () { if (document.hidden) hide(); });
})();
